/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Visibility_UnlistedInputs */

const en_dialog_visibility_unlisted = /** @type {(inputs: Dialog_Visibility_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlisted`)
};

const es_dialog_visibility_unlisted = /** @type {(inputs: Dialog_Visibility_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listado`)
};

/**
* | output |
* | --- |
* | "Unlisted" |
*
* @param {Dialog_Visibility_UnlistedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_visibility_unlisted = /** @type {((inputs?: Dialog_Visibility_UnlistedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Visibility_UnlistedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_visibility_unlisted(inputs)
	return en_dialog_visibility_unlisted(inputs)
});